(function () {
  var userAdding = false;
  var opening = false;
  var cartSnapshot = null;

  function getCart() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) { return response.json(); });
  }

  function getVariantId(holder) {
    var input = holder.closest('[data-form-holder]') && holder.closest('[data-form-holder]').querySelector('form[data-product-form] input[name="id"]');
    return input ? String(input.value) : '';
  }

  function syncQuantity(holder, cart) {
    var input = holder.querySelector('input[name="quantity"]');
    var plus = holder.querySelector('[x-stepper\\:plus]');
    var note = holder.querySelector('[data-chems-stock-note]');
    var section = holder.closest('[data-form-holder]');
    var addButton = section && section.querySelector('[data-add-to-cart]');
    if (!input) return;

    var inventory;
    try { inventory = JSON.parse(holder.getAttribute('data-inventory-map') || '[]'); } catch (error) { inventory = []; }
    var variantId = getVariantId(holder);
    var variant = inventory.find(function (item) { return String(item.id) === variantId; });
    if (!variant || !variant.limited) {
      input.removeAttribute('max');
      if (plus) plus.disabled = false;
      if (note) note.hidden = true;
      return;
    }

    var inCart = (cart.items || []).reduce(function (total, item) {
      return String(item.variant_id) === variantId ? total + item.quantity : total;
    }, 0);
    var remaining = Math.max(variant.quantity - inCart, 0);
    input.max = String(Math.max(remaining, 1));
    if (Number(input.value) > remaining && remaining > 0) {
      input.value = String(remaining);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (plus) plus.disabled = remaining <= Number(input.value);
    if (note) {
      note.hidden = remaining > 0;
      note.textContent = remaining > 0 ? '' : 'De beschikbare voorraad van deze uitvoering zit al in je winkelwagen.';
    }
    if (addButton) addButton.disabled = remaining < 1;
  }

  function syncAll(cart) {
    cartSnapshot = cart;
    document.querySelectorAll('[data-chems-quantity]').forEach(function (holder) { syncQuantity(holder, cart); });
  }

  function refreshLimits() {
    getCart().then(syncAll).catch(function () {});
  }

  function openDrawer() {
    if (opening) return;
    opening = true;
    window.setTimeout(function () {
      var noticeClose = document.querySelector('[data-product-add-popup] [data-close]');
      if (noticeClose) noticeClose.click();
      var cartToggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
      if (cartToggle) cartToggle.click();
      window.setTimeout(function () { opening = false; }, 250);
    }, 120);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    userAdding = true;
    getCart().then(function (cart) { cartSnapshot = cart; }).catch(function () {});
    window.setTimeout(function () {
      var error = form.querySelector('[data-error-display]');
      if (!error || !error.textContent.trim()) return;
      getCart().then(function (cart) {
        var previousCount = cartSnapshot ? cartSnapshot.item_count : 0;
        syncAll(cart);
        if (cart.item_count !== previousCount) {
          sessionStorage.setItem('chems-open-cart', '1');
          window.location.reload();
        }
      }).catch(function () {});
    }, 900);
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-add-to-cart], .btn--add-to-cart, button[name="add"]')) userAdding = true;
    if (event.target.closest('[data-form-holder] input[type="radio"], [data-form-holder] label')) {
      window.setTimeout(refreshLimits, 80);
      window.setTimeout(refreshLimits, 350);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.closest('[data-form-holder]')) window.setTimeout(refreshLimits, 30);
  }, true);

  document.addEventListener('theme:cart:change', function (event) {
    if (event.detail && event.detail.cart) syncAll(event.detail.cart);
    if (!userAdding || !event.detail || !event.detail.cart) return;
    userAdding = false;
    openDrawer();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshLimits);
  else refreshLimits();

  if (sessionStorage.getItem('chems-open-cart') === '1') {
    sessionStorage.removeItem('chems-open-cart');
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openDrawer);
    else openDrawer();
  }
})();

